import styled from 'styled-components'

export const CardFeaturedBg = styled.div`
    width: 100vw;
    height: auto;
    background-image: url('assets/images/background.jpg');
    background-color: '#ffff';
    background-repeat: no-repeat;
    background-size: cover;
`